<kendo-grid
  #kendoGrid
  [data]="gridWrapper.gridData"
  [loading]="gridWrapper.loading"
  [height]="(bodyHeight$ | async) || 400"
  scrollable="virtual"
  rowHeight="54px"
  [skip]="gridWrapper.gridState.skip"
  [pageSize]="gridWrapper.gridState.take"
  kendoGridSelectBy="id"
  [selectedKeys]="gridWrapper.mySelection"
  [sortable]="true"
  [groupable]="true"
  [group]="gridWrapper.gridState.group"
  [sort]="gridWrapper.gridState.sort"
  (groupChange)="gridWrapper.groupChanged($event)"
  (dataStateChange)="gridWrapper.onDataStateChange($event)"
  [reorderable]="true"
  [resizable]="true"
  filterable="menu"
>
  <kendo-grid-messages
    [noRecords]="gridWrapper.loading ? '' : 'Aucun résultat'"
    groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper..."
  >
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <input #mainFilter placeholder="Rechercher..." kendoTextBox (input)="gridWrapper.onFilter($event.target)" />
    <button
      mat-icon-button
      color="primary"
      [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
      (click)="mainFilter.value = ''; gridWrapper.clearFilter()"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </ng-template>

  <kendo-grid-column field="nomSousSysteme" title="Nom sous système" [width]="200">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <app-multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="distinctPrimitive(column.field)"
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="nom" title="Nom" [width]="150" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="localisation" title="Localisation" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="descriptionEtat" title="Etat" width="120">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <app-multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="distinctPrimitive(column.field)"
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="message" title="Message" filterable="false"> </kendo-grid-column>

  <kendo-grid-column field="urlAction1" title="Actions" filterable="false">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
        <button mat-icon-button color="primary" (click)="zoomTo($event, dataItem)" matTooltip="Voir sur la carte">
          <mat-icon>zoom_in</mat-icon>
        </button>

        <a
          class="action-button"
          mat-raised-button
          color="primary"
          [matTooltip]="dataItem.nomAction1"
          [href]="dataItem.urlAction1"
          target="_blank"
        >
          {{ dataItem.nomAction1 }}
        </a>
        <a
          class="action-button"
          mat-raised-button
          color="primary"
          [matTooltip]="dataItem.nomAction2"
          [href]="dataItem.urlAction2"
          target="_blank"
        >
          {{ dataItem.nomAction2 }}
        </a>
        <a
          class="action-button"
          mat-raised-button
          color="primary"
          [matTooltip]="dataItem.nomAction3"
          [href]="dataItem.urlAction3"
          target="_blank"
        >
          {{ dataItem.nomAction3 }}
        </a>
      </div>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
